import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { miscLinks, onboardingLink } from '../../../utils/internalLinks';
import LeftArrow from '../../../assets/images/login/left-arrow.svg';
import {
  nameLength,
  emailLength,
  passwordLength,
  minPasswordLength,
} from '../../../utils/commonVariables';
import CloseIcon from '../../../assets/images/login/close.svg';
import { validNameCharacters, checkValidEmails, passwordRegex, newPasswordLength } from '../../../utils/helper';
import { register, emailOtpVerification } from '../../../actions/login/register';
import SignupEmailOtpForm from './SignupEmailOtpForm';
import EyeOpen from '../../../assets/images/login/eye-view.svg';
import EyeClose from '../../../assets/images/login/eye-close.svg';

const errorTexts = {
  name: 'Please enter valid name.',
  email: 'Email address in not valid.',
  password: `Please choose a stronger password of at least ${minPasswordLength} characters.`,
  sameEmailPassword: `Password and email should not be similar`,
  confirmPassword: 'Password fields do not match',
  submitFailure: 'Something went wrong. Please try again',
};

const RegisterViaEmailForm = (props) => {
  const [name, setName] = useState(''),
    [email, setEmail] = useState(''),
    [password, setPassword] = useState(''),
    [confirmPassword, setConfirmPassword] = useState(''),
    [nameError, setNameError] = useState(false),
    [emailError, setEmailError] = useState(false),
    [passwordError, setPasswordError] = useState(false),
    [sameEmailPasswordError, setSameEmailPasswordError] = useState(false),
    [confirmPasswordError, setConfirmPasswordError] = useState(false),
    [submitError, setSubmitError] = useState(false),
    [submitting, setSubmitting] = useState(false),
    [showEmailOtpForm, setShowEmailOtpForm] = useState(false),
    [showPassword, setShowPassword] = useState({
      new_password: false,
      confirm_password: false
    }),
    [token, setToekn] = useState('')
  function _isValid() {
    let isValid = true;
    setNameError(false);
    setEmailError(false);
    setPasswordError(false);
    setConfirmPasswordError(false);
    setSubmitError(false);
    setSameEmailPasswordError(false);
    if (!name || !name.trim().length || !validNameCharacters(name)) {
      setNameError(true);
      isValid = false;
    }
    if (!email || !email.trim().length || !checkValidEmails(email.trim())) {
      setEmailError(true);
      isValid = false;
    }
    if (!password || (password && password.length < minPasswordLength)) {
      setPasswordError(true);
      isValid = false;
    }
    if (password && password.indexOf(email) > -1 && !passwordError) {
      setSameEmailPasswordError(true);
      isValid = false;
    }
    if (!confirmPassword || (confirmPassword && confirmPassword !== password)) {
      setConfirmPasswordError(true);
      isValid = false;
    }
    return isValid;
  }

  function _handleSubmit(e) {
    e.preventDefault();
    if (!_isValid() || submitting) return;
    const data = {
      user: {
        name: name.trim(),
        email: email.trim(),
        password,
        password_confirmation: confirmPassword,
      },
    };
    setSubmitting(true);
    const { register } = props;
    register(data).then((val) => {
      if (!val.status) {
        setSubmitting(false);
        setSubmitError(val.error || errorTexts.submitFailure);
      } else {
        setShowEmailOtpForm(true)
        setSubmitting(false);
        setToekn(val.data)
      }
    });
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target
    if (name === "password") {
      setPassword(value);
    }
    if (name === "password_confirmation") {
      setConfirmPassword(value);
    }
  }
  const handleTogglePasswordVisibility = (type) => {
    if (type === "password") {
      setShowPassword((prevState) => ({
        ...prevState,
        new_password: !showPassword.new_password
      }))
    }
    if (type === "confirm-password") {
      setShowPassword((prevState) => ({
        ...prevState,
        confirm_password: !showPassword.confirm_password
      }))
    }
  }
  const
    isConfirmPassword = password !== confirmPassword,
    isMatching = (!confirmPassword || isConfirmPassword),
    isDisabled = (password.length < 6 || !passwordRegex.test(password) || isMatching),
    isConfirmPasswordError = !!confirmPassword && isConfirmPassword,
    isError = !!password && (password.length < newPasswordLength || !passwordRegex.test(password) || isConfirmPasswordError),
    isPasswordLength = !!password && password.length < newPasswordLength,
    isPassowrdRegExMatch = !!password && !passwordRegex.test(password);
  return (
    <div className="login-form">
      {
        showEmailOtpForm ?
          <SignupEmailOtpForm {...props} email={email} token={token} toggleEmailForm={() => setShowEmailOtpForm(false)} />
          :
          <div className="login-form__backdrop">
            {props.shouldOnlyToggle ? (
              <button type="button" className="login-form__cancel" onClick={props.toggleLoginForm}>
                <img src={CloseIcon} alt="go to homepage" />
              </button>
            ) : (
              <Link to={miscLinks.home} className="login-form__cancel">
                <img src={CloseIcon} alt="go to homepage" />
              </Link>
            )}
            <div className="login-form__container">
              <div className="login-form__header">
                <img
                  onClick={() => {
                    if (props.shouldOnlyToggle && props.openSocialLogin) {
                      props.openSocialLogin();
                      return;
                    }
                    props.toggleRegisterForm();
                  }}
                  className="cursor-pointer login-form__header__icon"
                  src={LeftArrow}
                  alt="other login channels"
                />
                <p className="login-form__title">Sign up via Email</p>
              </div>
              <form disabled={submitting} onSubmit={_handleSubmit} className="login-form__form">
                <div className="login-form__form__group">
                  <input
                    type="text"
                    placeholder="Full Name"
                    autoFocus={true}
                    value={name}
                    maxLength={nameLength}
                    onChange={(e) => setName(e.target.value)}
                    className="login-form__form__input login-form__form__input--name"
                    required
                  />
                  {nameError && <p className="error-text">{errorTexts.name}</p>}
                </div>
                <div className="login-form__form__group">
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    maxLength={emailLength}
                    onChange={(e) => setEmail(e.target.value)}
                    className="login-form__form__input login-form__form__input--email"
                    required
                  />
                  {emailError && <p className="error-text">{errorTexts.email}</p>}
                </div>
                <div className="login-form__form__group">

                  <input
                    type={!!showPassword.new_password ? 'text' : 'password'}
                    placeholder="Password"
                    value={password}
                    name="password"
                    maxLength={passwordLength}
                    autoComplete="new-password"
                    onChange={(e) => handleInputChange(e)}
                    className={`login-form__form__input login-form__form__input--password ${!!isError ? "red" : ""}`}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => handleTogglePasswordVisibility("password")}
                    className="login-form__form__helper-btn cursor-pointer"
                  >
                    <img src={!!showPassword.new_password ? EyeOpen : EyeClose} alt="show password" />
                  </button>

                  {passwordError && <p className="error-text">{errorTexts.password}</p>}
                  {sameEmailPasswordError && (
                    <p className="error-text">{errorTexts.sameEmailPassword}</p>
                  )}
                </div>
                <div className="login-form__form__group">
                  <input
                    type={!!showPassword.confirm_password ? 'text' : 'password'}
                    placeholder="Confirm Password"
                    name="password_confirmation"
                    value={confirmPassword}
                    maxLength={passwordLength}
                    autoComplete="new-password"
                    onChange={(e) => handleInputChange(e)}
                    className={`login-form__form__input login-form__form__input--password ${!!isConfirmPasswordError ? "red" : ""}`}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => handleTogglePasswordVisibility("confirm-password")}
                    className="login-form__form__helper-btn cursor-pointer"
                  >
                    <img src={!!showPassword.confirm_password ? EyeOpen : EyeClose} alt="show password" />
                  </button>
                  {confirmPasswordError && <p className="error-text">{errorTexts.confirmPassword}</p>}
                  {submitError && <p className="error-text">{submitError}</p>}
                </div>
                <div>
                  <ul className='profile-form-modals__form-confirm-list'>
                    {!!isConfirmPasswordError && <li className={`item ${!!isConfirmPassword ? "red" : ""}`}>New and Confirm password not matching.</li>}
                    <li className={`item ${!!isPasswordLength ? "red" : ""}`}>Min length as {newPasswordLength} characters.</li>
                    <li className={`item ${!!isPassowrdRegExMatch ? "red" : ""}`}>One Caps, One Small, One numeric and One Special character validation ex. @#%*&.</li>
                  </ul>
                </div>
                <button
                  type="submit"
                  disabled={submitting || !!isDisabled}
                  className={`login-form__action__btn login-form__action__btn--default
                            ${submitting ? 'login-form__action__btn--disabled' : ''}
                            ${!!isDisabled ? "disabled" : ""}`}
                >
                  Sign up
                </button>
              </form>
              <div>
                <p className="login-form__link">
                  Already have an account?
                  {props.shouldOnlyToggle && props.openLoginForm ? (
                    <button
                      onClick={props.openLoginForm}
                      className="login-form__link login-form__link--btn login-form__link--blue"
                    >
                      Log In
                    </button>
                  ) : (
                    <Link className="login-form__link login-form__link--blue" to={miscLinks.login}>
                      Log In
                    </Link>
                  )}
                </p>
                <p className="login-form__helper-link">
                  By signing up on TagTaste, you are agreeing to our {" "}
                  <Link
                    className="login-form__helper-link login-form__helper-link--blue"
                    to={miscLinks.terms}
                  >
                    Terms &amp; Conditions {" "}
                  </Link>
                  and {" "}
                  <Link
                    className="login-form__helper-link login-form__helper-link--blue"
                    to={miscLinks.privacy}
                  >
                    Privacy Policy
                  </Link>
                </p>
              </div>
            </div>
          </div>
      }
    </div>
  );
};

RegisterViaEmailForm.propTypes = {
  toggleRegisterForm: PropTypes.func,
  shouldOnlyToggle: PropTypes.bool,
  publicPageLink: PropTypes.string,
  openSocialLogin: PropTypes.func,
  openLoginForm: PropTypes.func,
  toggleLoginForm: PropTypes.func,
  toggleEmailOtpForm: PropTypes.func,
  history: PropTypes.object,
  register: PropTypes.func,
};

export default withRouter(connect(null, { register })(RegisterViaEmailForm));
